import { Box, Button, Grid, Stack, TextField, Typography } from "@mui/material";
import FastRewindIcon from "@mui/icons-material/FastRewind";
import React from "react";
import boxStyles from "../../../../styles/boxStyles";
import footerLaporanStyles from "../../../../styles/footerLaporanStyles";

const FooterInvestigasi = ({ handleSubmit }) => {
  return (
    <div>
      <Grid container spacing={5}>
        <Grid item xl={12} lg={12} sm={12} xs={12}>
          <Box sx={footerLaporanStyles} component="div">
            <Grid container>
              <Grid
                item
                xl={3}
                lg={3}
                sm={3}
                xs={12}
                textAlign="center"
                justifyContent={"center"}
                alignItems={"center"}
                display="flex"
              >
                <h2>Tim Investigasi</h2>
              </Grid>
              <Grid item xl={9} lg={9} sm={9} xs={12}>
                <Stack spacing={2} direction="row">
                  <TextField
                    name={"nama"}
                    label="Nama"
                    variant="standard"
                    fullWidth
                    type="text"
                  />
                  <TextField
                    name="nopek"
                    label="Nopek"
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                    fullWidth
                    type="text"
                  />
                  <TextField
                    name="Jabatan"
                    label="jabatan"
                    variant="standard"
                    fullWidth
                    type="text"
                  />
                  <TextField
                    name="jabatanTimInvestigasi"
                    label="Jabatan Tim Investigasi"
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                    fullWidth
                    type="text"
                    value="Ketua Tim Investigasi"
                  />
                </Stack>
                <Stack spacing={2} direction="row">
                  <TextField
                    name={"nama"}
                    label="Nama"
                    variant="standard"
                    fullWidth
                    type="text"
                  />
                  <TextField
                    name="nopek"
                    label="Nopek"
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                    fullWidth
                    type="text"
                  />
                  <TextField
                    name="Jabatan"
                    label="jabatan"
                    variant="standard"
                    fullWidth
                    type="text"
                  />
                  <TextField
                    name="jabatanTimInvestigasi"
                    label="Jabatan Tim Investigasi"
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                    fullWidth
                    type="text"
                    value="Anggota"
                  />
                </Stack>
                <Stack spacing={2} direction="row">
                  <TextField
                    name={"nama"}
                    label="Nama"
                    variant="standard"
                    fullWidth
                    type="text"
                  />
                  <TextField
                    name="nopek"
                    label="Nopek"
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                    fullWidth
                    type="text"
                  />
                  <TextField
                    name="Jabatan"
                    label="jabatan"
                    variant="standard"
                    fullWidth
                    type="text"
                  />
                  <TextField
                    name="jabatanTimInvestigasi"
                    label="Jabatan Tim Investigasi"
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                    fullWidth
                    type="text"
                    value="Anggota"
                  />
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xl={12} lg={12} sm={12} xs={12}>
          <Grid container>
            <Grid item xl={6} lg={6} sm={6} xs={12}>
              <Stack spacing={2}>
                <div style={{ textAlign: "center" }}>
                  <Typography variant="caption">Dibuat oleh:</Typography>
                  <Typography variant="body1">
                    <b>(Ketua Tim Investigasi)</b>
                  </Typography>
                  <br />
                  <br />
                  <br />
                  <br />
                  <Typography variant="body1">
                    <b>Nama Lengkap / Jabatan</b>
                  </Typography>
                  <Typography variant="subtitle1">
                    {new Date().toLocaleDateString().toString()}
                  </Typography>
                </div>
              </Stack>
            </Grid>
            <Grid item xl={6} lg={6} sm={6} xs={12}>
              <Stack spacing={2}>
                <div style={{ textAlign: "center" }}>
                  <Typography variant="caption">Mengetahui:</Typography>
                  <Typography variant="body1">
                    <b>(Terminal Manager/Manajer Region/VP)</b>
                  </Typography>
                  <br />
                  <br />
                  <br />
                  <br />
                  <Typography variant="body1">
                    <b>Nama Lengkap / Jabatan</b>
                  </Typography>
                  <Typography variant="subtitle1">
                    {new Date().toLocaleDateString().toString()}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <br />
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: "10vh" }}
      >
        <Grid item xs={3}>
          <Stack spacing={2} direction="row">
            <Button variant="outlined" sx={{ width: "150px" }}>
              Save As Draft
            </Button>
            <Button
              variant="contained"
              sx={{ width: "150px" }}
              type="submit"
              onClick={handleSubmit}
            >
              SUBMIT
            </Button>
          </Stack>
        </Grid>
      </Grid>
      <a href="/hsse/incident/dashboardlkp" style={{ textDecoration: "none" }}>
        <Button
          variant="text"
          startIcon={<FastRewindIcon />}
          sx={{ color: "black" }}
        >
          Back
        </Button>
      </a>
    </div>
  );
};

export default FooterInvestigasi;
